
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * ProtectedRoute asegura que el usuario esté autenticado.
 * Opcionalmente puede requerir un rol específico (admin o team).
 */
const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { user, loading, isAdmin } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen pt-20 flex items-center justify-center bg-gray-50">
                <Loader2 className="w-10 h-10 animate-spin text-[#0A5F7F]" />
            </div>
        );
    }

    if (!user) {
        // Redirigir al admin login si no hay sesión, guardando la ubicación original
        return <Navigate to="/admin" state={{ from: location }} replace />;
    }

    if (requireAdmin && !isAdmin) {
        // Si requiere ser admin y no lo es, redirigir al portal de equipo
        return <Navigate to="/equipo" replace />;
    }

    return children;
};

export default ProtectedRoute;
